import { z } from 'zod';
import { PostsProjectType } from '../constants';

export const missingPostDayStatusSchema = z.enum(['missing', 'ignored']);

export type MissingPostDayStatus = z.infer<typeof missingPostDayStatusSchema>;

export const missingPostDaySchema = z.object({
  type: z.nativeEnum(PostsProjectType),
  date: z.string(),
  status: missingPostDayStatusSchema,
});

export type MissingPostDaySchema = z.infer<typeof missingPostDaySchema>;

/** Running deficit for a monthly-quota deliverable type (e.g. "2 LinkedIn articles/month"). */
export const monthlyDeficitSchema = z.object({
  type: z.nativeEnum(PostsProjectType),
  /** 'YYYY-MM' */
  month: z.string(),
  target: z.number(),
  actual: z.number(),
  deficit: z.number(),
});

export type MonthlyDeficitSchema = z.infer<typeof monthlyDeficitSchema>;

export const clientMissingDeliverablesSchema = z.object({
  days: z.array(missingPostDaySchema),
  monthly: z.array(monthlyDeficitSchema),
});

export type ClientMissingDeliverablesSchema = z.infer<typeof clientMissingDeliverablesSchema>;

export const missingPostsSchema = z.object({
  clients: z.record(z.string(), clientMissingDeliverablesSchema),
});

export type MissingPostsSchema = z.infer<typeof missingPostsSchema>;
